export default __webpack_public_path__ + "locales/sr-Latn-RS/Common.json?hash=30427a4fd24f07da065b4d5f89489c40";